import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/AuthNavbar";
// components
import AllTimeMsg from "components/CardsForMarketing/AllTimeMsg";
import AllTypeOfMsgCount from "components/CardsForMarketing/AllTypeOfMsgCount";
import UserMessageCounts from "components/CardsForMarketing/UserMessageCounts";
import ColumnChart from "components/Cards/ColumnChart";
import ColumnChartForMarketing from "components/CardsForMarketing/ColumnChartForMarketing";
import HeaderStatForExpDashboard from "components/CardsForMarketing/HeaderStatForExpDashboard";

export default function MarketingDashboard() {
  const history = useHistory();

  useEffect(() => {
    // Check if user is not logged in (localStorage is empty)
    if (!localStorage.getItem("userData")) {
      // Redirect to the login page
      history.push("/login");
    }
  }, [history]);

  // Get userId from local storage
  const storedUserData = localStorage.getItem("userData");
  let userId = "";
  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
  }

  return (
    <>
      <Navbar />
      <div className="flex flex-wrap ">
        <div className="w-full xl:w-12/12 mb-6 xl:mb-0 px-4">
          <AllTimeMsg />
        </div>
      </div>

      {/* New Card with message counts */}
      <div className="flex flex-wrap  ">
        <div className="w-full xl:w-12/12 mb-12 xl:mb-0 px-4">
          <UserMessageCounts />
        </div>
      </div>

      <div className="flex flex-wrap  ">
        <div className="w-full xl:w-12/12 mb-12 xl:mb-0 px-4">
          {/* <ColumnChart /> */}
          <ColumnChartForMarketing />
        </div>
      </div>
      <Footer />
    </>
  );
}
